var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8078C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9949 9.34939 20.9397 6.80881 19.0655 4.93455C17.1912 3.06028 14.6506 2.00508 12 2ZM18.3269 17.6154C17.7043 16.7222 16.9019 15.9689 15.9712 15.4038C14.9026 16.4276 13.4799 16.9991 12 16.9991C10.5201 16.9991 9.09745 16.4276 8.02885 15.4038C7.09815 15.9689 6.29575 16.7222 5.67308 17.6154C4.59017 16.3959 3.88274 14.8895 3.63593 13.2774C3.38911 11.6654 3.61343 10.0163 4.28188 8.5287C4.95033 7.04112 6.03443 5.7784 7.40372 4.89252C8.77301 4.00664 10.3691 3.53533 12 3.53533C13.6309 3.53533 15.227 4.00664 16.5963 4.89252C17.9656 5.7784 19.0497 7.04112 19.7181 8.5287C20.3866 10.0163 20.6109 11.6654 20.3641 13.2774C20.1173 14.8895 19.4098 16.3959 18.3269 17.6154Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/user-filled.9796114a36a8c19ab893e84e24d2e3c1.svg";
export { ForwardRef as ReactComponent };